export enum BusinessInsuredObject {
  GOODS = 'GOODS',
  COMPUTER_HARDWARE = 'COMPUTER_HARDWARE',
  MACHINE_TOOL = 'MACHINE_TOOL',
  OFFICE_FURNITURE = 'OFFICE_FURNITURE',
}

export const getBusinessInsuredObjectLabel = (object: BusinessInsuredObject) => {
  switch (object) {
    case BusinessInsuredObject.GOODS:
      return $localize`Marchandises`;
    case BusinessInsuredObject.COMPUTER_HARDWARE:
      return $localize`Matériel informatique`;
    case BusinessInsuredObject.MACHINE_TOOL:
      return $localize`Machines outils`;
    case BusinessInsuredObject.OFFICE_FURNITURE:
      return $localize`Mobilier de bureau`;
    default:
      return '';
  }
};
